import { useState, useEffect } from 'react';
import { RouteComponentProps } from '@reach/router';
import { PolicyStreamPageContainer } from './components/PageContainer';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { usePolicyStreamGoogleAnalytics } from '../../hooks/usePolicyStreamGoogleAnalytics';
import {
  GAEventNames,
  EventActions,
} from '../../hooks/usePolicyStreamGoogleAnalytics/types';
import { PolicyStreamButtonsContainer } from './components';
import {
  useSetPolicyStreamSaveButtonVisibility,
  useSettings,
} from '../../hooks';
import { useDispatch, useSelector } from 'react-redux';
import {
  policystreamStore,
  getLastSubmittedQuote,
} from '../../store/policystreamStore';
import { useScrollToTopOnInitialMount } from '@calefy-inc/hooks';
const {
  actions: { resetState },
} = policystreamStore;

export const PolicyStreamDonePage = (_props: RouteComponentProps) => {
  const myAnalytics = usePolicyStreamGoogleAnalytics();

  useScrollToTopOnInitialMount();
  useSetPolicyStreamSaveButtonVisibility(false);
  const [destination, setDestination] = useState<string>('');
  const { settings } = useSettings();
  const dispatch = useDispatch();
  const lastSubmittedQuote = useSelector(getLastSubmittedQuote);

  // Send Google Analytics event on component load
  useEffect(() => {
    myAnalytics?.triggerEvent(
      GAEventNames.Done,
      EventActions.PageLoad,
      'PolicyStream Done Page',
    );
  }, [myAnalytics]);

  useEffect(() => {
    dispatch(resetState());
  }, []);

  useEffect(() => {
    if (settings.homepage) {
      setDestination(settings.homepage);
    } else {
      setDestination(window.location.origin);
    }
  }, [settings]);

  return (
    <PolicyStreamPageContainer>
      <h2>Thank you</h2>
      {lastSubmittedQuote && lastSubmittedQuote.status === 'INCOMPLETE' ? (
        <Typography>
          Your application has been successfully saved for later. An email has
          been sent to the address you provided, containing a link to resume
          your application at any time. Thank you for trusting us with your life
          insurance information.
        </Typography>
      ) : (
        <Typography>
          Congratulations on submitting your application for life insurance! Our
          team has received your application and will be reviewing it within the
          next 24 hours. Make sure to check your email for updates regarding
          your application!
        </Typography>
      )}
      <PolicyStreamButtonsContainer>
        {destination ? (
          <Button component={'a'} href={destination}>
            Home
          </Button>
        ) : null}
      </PolicyStreamButtonsContainer>
    </PolicyStreamPageContainer>
  );
};
